import { ExpandLessRounded, ExpandMoreRounded } from "@mui/icons-material"
import { Button } from "@mui/material"

type Props = {
  controlsId: string
  expanded: boolean
  onClick: () => void
}

const FilterCollapseButton = ({ controlsId, expanded, onClick }: Props) => {
  return (
    <Button
      aria-controls={controlsId}
      aria-expanded={expanded}
      onClick={onClick}
      size="small"
      startIcon={expanded ? <ExpandLessRounded /> : <ExpandMoreRounded />}
      sx={(theme) => ({ minWidth: theme.spacing(15) })}
      variant="outlined"
    >
      {expanded ? "Ẩn bộ lọc" : "Hiện bộ lọc"}
    </Button>
  )
}

export default FilterCollapseButton
